module.exports = __webpack_public_path__ + "static/JetBrainsMono-Italic-8d0942fbfa63674fa465f104ca33e043.ttf";